
import axios from 'axios';

import env from 'configures';

import {
  REGISTER_ORDER_PATH,
  EKI_SUGGEST_PATH,
  CHECK_EKICODE_PATH,
  KIGYOU_SUGGEST_PATH,
  HOURSALARY_SUGGEST_PATH,
  ADD_SEARCH_PATH,
  REGISTER_REQUEST_PATH,
  LEAVE_WITHOUT_ORDER_PATH,
} from 'utils/constant';

/*  駅サジェストAPI呼び出し */
export const ekiSuggestApi = async ({ searchText }) => {
  if(!searchText) return [];

  const { RJS_OPEN_API_ENDPOINT } = env;
  const suggestEndPoint = RJS_OPEN_API_ENDPOINT + EKI_SUGGEST_PATH;
  
  // パラメータ作成
  const prefectures = [ '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '19', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47' ];
  const areaParam = prefectures.map((p) => { return p; }).join('&todouhukenCd=');
  const suggestParam = `?searchTxt=${encodeURIComponent(searchText)}&todouhukenCd=${areaParam}`;
  // API呼び出し
  const searchEkiNames = await axios.get(suggestEndPoint + suggestParam).catch(err => {
    console.log('ekiSuggestApi: catch');
    throw err;
  });

  // 重複排除して返却
  return searchEkiNames.data;
};

/*  サービス対象チェックAPI呼び出し */
export const checkEkiCode = async ({ ekiCd }) => {
  const { OD_SERVICE_API_ENDPOINT } = env;
  const endpoint = OD_SERVICE_API_ENDPOINT + CHECK_EKICODE_PATH;

  // パラメータ作成
  const param = `?ekiCd=${ekiCd}`;
  // API呼び出し
  const ret = await axios.get(endpoint + param).catch(err => {
    console.log('checkEkiCode: catch');
    throw err;
  });

  // console.log('[ checkEkiCode ]');
  return !!ret;
};

/*  時給相場金額取得API呼び出し */
export const getHourSalaryApi = async ({
  params,
}) => {
  const { OD_SERVICE_API_ENDPOINT } = env;
  const endPoint = OD_SERVICE_API_ENDPOINT + HOURSALARY_SUGGEST_PATH;
  
  // パラメータ作成
  const map = Object.keys(params).map(key => `${key}=${params[key]}`);
  const param = `?${map.join('&')}`;
  // API呼び出し
  const hourSalary = await axios.get(endPoint + param).catch(err => {
    console.log('getHourSalaryApi: catch');
    throw err;
  });
  if(!hourSalary) return 0;

  // 返却
  return hourSalary.data.suggestHourSalary;
};

/* 住所サジェストAPI呼び出し */
export const AddressSearchApi = async (searchText) => {
  const { RJS_OPEN_API_ENDPOINT } = env;
  const suggestEndPoint = RJS_OPEN_API_ENDPOINT + ADD_SEARCH_PATH;
  // パラメータ作成
  const suggestParam = `?zip=${encodeURIComponent(searchText)}&addrSyuurokuKbn=00`;
  // API呼び出し
  const searchAddress = await axios.get(suggestEndPoint + suggestParam).catch(err => {
    console.log('AddressSearchApi: catch');
    throw err;
  });
  if(!searchAddress) return [];
  const AddressList = searchAddress.data.map(line => line.address);
  return [ ...new Set(AddressList) ];
};

/* オンライン発注 データ登録 更新処理 */
export const postRegisterOrderApi = async ({ params })=>{
  // パラメータ作成
  const { OD_SERVICE_API_ENDPOINT } = env;
  const endPoint = OD_SERVICE_API_ENDPOINT + REGISTER_ORDER_PATH;
  // API呼び出し
  await axios.post(endPoint, params).catch(err => {
    console.log('postRegisterOrderApi: catch');
    throw err;
  });
};

/* 派遣依頼相談 データ登録 更新処理 */
export const postRegisterRequestApi = async ({ params })=>{
  // パラメータ作成
  const { OD_SERVICE_API_ENDPOINT } = env;
  const endPoint = OD_SERVICE_API_ENDPOINT + REGISTER_REQUEST_PATH;
  // API呼び出し
  await axios.post(endPoint, params).catch(err => {
    console.log('postRegisterRequestApi: catch');
    throw err;
  });  
};

/* オンライン発注入力フォーム オンライン発注追加入力なし離脱 更新処理 */
export const postLeaveWithoutOrderApi = async ({ params })=>{
  // パラメータ作成
  const { OD_SERVICE_API_ENDPOINT } = env;
  const endPoint = OD_SERVICE_API_ENDPOINT + LEAVE_WITHOUT_ORDER_PATH;
  // API呼び出し
  await axios.post(endPoint, params).catch(err => {
    console.log('postLeaveWithoutOrderApi: catch');
    throw err;
  });  
};